export default __webpack_public_path__ + "static/media/reward-tiers4.36c0f212.webp";